// @flow
import React, { Component } from 'react'
import Background from 'client/components/background'
import { Outlet } from 'react-router-dom'
// $FlowFixMe
class Container extends Component {
  render (): any {
    const { auth, client } = this.props

    return (
      <div className='container'>
        <div className='wrapper'>
          {auth && client && <Outlet context={{ auth, client }} />}
          <div className='content'>
            <div className='content__wrapper'>
              <h1 className='logo' />
              <p className='content__description'>Improving qualification, visibility, and accountability</p>
            </div>
          </div>
        </div>
        <Background />
      </div>
    )
  }
}

export default Container
